import { WordCustomizations } from '@uifabric/theme-samples';
import { Theme } from '@fluentui/theme';

export const WordTheme: Theme = WordCustomizations.settings.theme;
